export const DOCUMENTS_TAB_KEY = 'documents' as const
export const COMPANIES_TAB_KEY = 'companies' as const
export const COMPANY_TAB_KEY = 'company' as const
export const TEMPLATES_TAB_KEY = 'templates' as const
